export const ILLEGAL_TRITS_LENGTH = 'Illegal trits length'
export const ILLEGAL_WORDS_LENGTH = 'Illegal words length'
